import React, { useEffect, useRef, useState } from 'react';
import BoligmappaHeaderLogo from '@/assets/images/BM-header-logo.svg';
import { Button } from '@/components/ui/button';
import {
  bmPlusNavbarMenu,
  newMobileMenu,
  servicesNavbarMenu,
} from '@/structure/menu';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { getDashboardLinkPrefix } from '@/utils/routes';
import clsx from 'clsx';
import { useParams } from 'react-router';

const MobileHeader = ({
  allProperties,
  ownedProperties,
  activeProperty,
  documentsToSigned,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeList, setActiveList] = useState([]);
  const headerRef = useRef();
  const { pathname } = useLocation();
  const history = useHistory();
  const dashboardLinkPrefix = getDashboardLinkPrefix(
    activeProperty?.boligmappaNumber || allProperties[0]?.boligmappaNumber
  );
  const { boligmappaNumber } = useParams();

  const ownedPropertyDefaultDashboardLinkPrefix = getDashboardLinkPrefix(
    (activeProperty?.owned && activeProperty?.boligmappaNumber) ||
      (ownedProperties && ownedProperties[0]?.boligmappaNumber)
  );

  const onListToggle = (propertyMenuItem) => {
    if (activeList.some((el) => propertyMenuItem.boligmappaNumber === el)) {
      setActiveList((prev) =>
        prev.filter((el) => propertyMenuItem.boligmappaNumber !== el)
      );
    } else {
      setActiveList((prev) => [...prev, propertyMenuItem.boligmappaNumber]);
    }
  };

  const isActive = (propertyMenuItem) =>
    activeList.some((el) => propertyMenuItem?.boligmappaNumber === el);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isMenuOpen]);

  useEffect(() => {
    if (boligmappaNumber) {
      setActiveList([boligmappaNumber]);
    }
  }, [boligmappaNumber]);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <>
      <div
        ref={headerRef}
        className="fixed font-circular w-full z-10 bg-white flex justify-between py-[11px] px-5 border-b"
      >
        <Link className="flex items-center w-full" to="/">
          <img
            className="max-w-[110px]"
            alt="logo"
            src={BoligmappaHeaderLogo}
          />
        </Link>
        <Button
          className="hover:bg-transparent"
          variant="ghost"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <p className="text-[15px] font-bold text-foreground">
            {isMenuOpen ? 'Lukk' : 'Meny'}
          </p>
        </Button>
      </div>
      <div
        className={`fixed top-0 z-[9999] font-circular w-full h-[calc(100%-59px)] bg-white overflow-scroll transition-[0.3s] px-5 py-2 ${
          isMenuOpen ? 'left-0' : 'left-[100%]'
        }`}
        style={{ top: `${headerRef.current?.offsetHeight}px` }}
      >
        {newMobileMenu(allProperties).map((propertyMenuItem) => {
          const Icon = propertyMenuItem.icon;
          return (
            <div
              key={propertyMenuItem.id}
              className={clsx([
                'py-2.5 px-2 rounded-lg',
                pathname.includes(propertyMenuItem.link) &&
                  'bg-primary-foreground shadow',
              ])}
            >
              <button
                onClick={() =>
                  propertyMenuItem.boligmappaNumber
                    ? onListToggle(propertyMenuItem)
                    : history.push(
                        propertyMenuItem.ownedPropertyRequired
                          ? `${ownedPropertyDefaultDashboardLinkPrefix}${propertyMenuItem.link}`
                          : propertyMenuItem.link
                      )
                }
                className="flex justify-between items-center w-full"
                type="button"
              >
                <div className="flex gap-3 items-center">
                  <Icon className="w-5" />
                  <h3 className="font-bold text-[15px]">
                    {propertyMenuItem.title}
                  </h3>
                </div>
                {propertyMenuItem.boligmappaNumber && (
                  <div className="flex items-center gap-2">
                    {documentsToSigned?.some(
                      (el) =>
                        el.boligmappaNumber ===
                        propertyMenuItem.boligmappaNumber
                    ) && (
                      <span className="bg-primary rounded-full h-[7px] w-[7px]" />
                    )}
                    <div
                      className={`flex justify-center items-center p-0 pb-[3px] text-xl border rounded-full h-[30px] w-[30px] ${
                        isActive(propertyMenuItem) && 'rotate-90'
                      }`}
                    >
                      ›
                    </div>
                  </div>
                )}
              </button>
              {propertyMenuItem.items?.length && (
                <ul
                  className={`transition-all duration-300 overflow-hidden ${
                    activeList.some(
                      (el) => el === propertyMenuItem.boligmappaNumber
                    )
                      ? 'max-h-96 py-1'
                      : 'max-h-0'
                  }`}
                >
                  {propertyMenuItem.items
                    .filter(
                      (menuItem) =>
                        !menuItem.documentsToSignedOnly ||
                        documentsToSigned?.some(
                          (el) =>
                            propertyMenuItem?.boligmappaNumber ===
                            el.boligmappaNumber
                        )
                    )
                    .map((childItem) => (
                      <li
                        key={childItem.id}
                        className={clsx([
                          'flex items-center justify-between text-[15px] ml-6 mr-1 py-2.5 px-2 rounded-lg',
                          pathname.includes(childItem.link) &&
                            activeProperty?.boligmappaNumber ===
                              propertyMenuItem?.boligmappaNumber &&
                            'bg-primary-foreground shadow',
                        ])}
                      >
                        <Link
                          to={`/dashboard/${propertyMenuItem.boligmappaNumber}/${childItem.link}`}
                        >
                          {childItem.title}
                        </Link>
                        {childItem.documentsToSignedOnly && (
                          <span className="bg-primary rounded-full h-[7px] w-[7px]" />
                        )}
                      </li>
                    ))}
                </ul>
              )}
            </div>
          );
        })}
        <div className="border-b mt-2" />
        <h3 className="mt-4 mb-4 text-[12.5px] font-medium uppercase text-sidebar-foreground/70">
          Boligmappa+
        </h3>
        <ul>
          {bmPlusNavbarMenu.map(
            (item) =>
              (!item.propertyRequired || allProperties.length > 0) && (
                <li
                  key={item.id}
                  className={clsx([
                    `flex items-center gap-3 p-2 rounded-[6px]`,
                    pathname.includes(item.link) &&
                      'bg-primary-foreground shadow',
                  ])}
                >
                  <item.icon width={20} height={20} />
                  <Link
                    to={
                      !item.propertyRequired
                        ? item.link
                        : `${dashboardLinkPrefix}/${item.link}`
                    }
                  >
                    {item.title}
                  </Link>
                </li>
              )
          )}
        </ul>
        {(allProperties.length > 0 ||
          servicesNavbarMenu.some((el) => !el.propertyRequired)) && (
          <h3 className="mt-6 mb-4 text-[12.5px] font-medium uppercase text-sidebar-foreground/70">
            Tjenester
          </h3>
        )}
        <ul className="pb-2">
          {servicesNavbarMenu.map((item) => {
            if (allProperties.length > 0 || !item.propertyRequired) {
              const Icon = item.mobileIcon;
              return (
                <li
                  key={item.id}
                  className={clsx([
                    'flex items-center gap-3 p-2 rounded-[6px]',
                    pathname.includes(item.link) &&
                      'bg-primary-foreground shadow',
                  ])}
                >
                  {Icon && <Icon className="w-5" width={20} height={20} />}
                  {item.isExternalLink ? (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  ) : (
                    <Link to={`${dashboardLinkPrefix}/${item.link}`}>
                      {item.title}
                    </Link>
                  )}
                </li>
              );
            }
            return null;
          })}
        </ul>
        <Link
          className="flex justify-self-center text-[15px] text-sidebar-foreground/70 px-4 pb-10"
          to="/logout"
        >
          Logg ut
        </Link>
      </div>
      <div style={{ height: `${headerRef.current?.offsetHeight}px` }} />
    </>
  );
};

export default MobileHeader;
